import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Cart from '@/components/cart/cart'
import ModalAddress from '@/components/modalAddressHome/modalAddress'
import ModalProgram from '@/components/modalAsideProgram/modalAsideProgram'
import AddressProgram from '@/components/addressProgram/addressProgram'
import CashbackNotification from '@/components/cashbackNotification/cashbackNotification'
import { localCurrency } from '@/plugins/currency'
import moment from 'moment'

@Component({
  components: {
    Cart,
    ModalAddress,
    ModalProgram,
    AddressProgram,
    CashbackNotification
  }
})
export default class AsideCart extends Vue {

  @Prop({ default: false }) show;

  @Action action_activateCartCoupon: any
  @Action action_deactivateCartCoupon: any

  @Getter getCity: any
  @Getter getCountry: any
  @Getter getIsToken: any
  @Getter getOpenCart: any
  @Getter getIsUnderMobile: any
  @Getter getIsXLScreen: any
  @Getter getCart: any
  @Getter getOpenCouponModal: any
  @Getter getPathTemporal: any
  @Getter getCurrentAddress;
  @Getter getCurrentProgram;
  @Getter getUser;

  @Mutation PATH_TEMPORAL
  @Mutation OPEN_CART
  @Mutation OPEN_COUPON_MODAL
  @Mutation CURRENT_ADDRESS

  isBtnLoad = false

  // Delivery
  total: number = 0
  missingToForFreeDeliveryRaw = 0

  // Address Modal
  showAddressModal = false
  selectedAddress = {}

  // Program Modal
  showProgramModal = false
  dayProgram = false

  // Coupon Modal
  couponText = "";
  showAddCouponBtn = true;
  showCouponModal = false;
  showCashbackMessage = true;

  async mounted() {
    if (this.$route.params.modal == 'program') {
      this._toggleProgramModal()
    }
    if (this.$route.params.modal == 'address') {
      this._toggleAddressModal()
    }
    if(this.getCouponApplied && this.getCouponApplied.code) {
      this.couponText = this.getCouponApplied.code;
    }
    if (
      this.getPathTemporal &&
      this.getPathTemporal.query &&
      this.getPathTemporal.query.openCoupon &&
      this.getIsToken
    ) {
      this.OPEN_COUPON_MODAL(true);
    }
  }

  get getCurrentProgramLabel() {
    let response = "";
    if (this.getCurrentProgram && this.getCurrentProgram.day) {
      response = moment(this.getCurrentProgram.day).format("ddd DD MMM");
    }
    return response;
  }

  get getCartProducts() {
    if(this.getCart && this.getCart.cart_products) {
      return this.getCart.cart_products;
    }
    return [];
  }

  get showAddCouponButton() {
    return (this.getCart && !this.getCart.coupon_applied);
  }

  get showAppliedCouponField() {
    return this.getCart && this.getCart.coupon_applied && this.getCart.coupon_data;
  }

  get getProductsQty() {
    const cart = this.getCart;
    let response = 0;
    if (cart) {
      const cartProducts = cart.cart_products;
      if (cartProducts.length) {
        let qty = 0;
        cartProducts.map((product) => {
          qty += product.quantity_total;
        });
        response = qty;
      }
    }
    return response;
  }

  get getDiscountTotal() {
    const cart = this.getCart;
    let response = 0;
    if(cart && cart.promo_discount_amount) {
      response = parseFloat(cart.promo_discount_amount);
    }
    return response;
  }

  get getCartSubtotal() {
    const cart = this.getCart;
    if(cart && cart.subtotal) {
      return this.localCurrencyFormat(cart.subtotal);
    }
    return 0;
  }

  get getTotalLabel() {
    const cart = this.getCart;
    if(cart && cart.total_decimal) {
      return this.localCurrencyFormat(cart.total_decimal);
    }
    return 0;
  }

  get getDeliveryItemLabel() {
    const cart = this.getCart;
    let response = 0;
    if(cart && cart.delivery) {
      response = cart.delivery;
    }
    return response;
  }

  get getPriceDelivery() {
    const variables = this.getCity.variables;
    let deliveryPrice =
      (variables &&
        variables.find((x) => {
          return x.name === "first_dish_delivery";
        }).value) ||
      0;
    return parseFloat(deliveryPrice);
  }

  get getProductsTotal() {
    const cart = this.getCart;
    if(cart && cart.total) {
      return this.$currency.format(cart.total, { code: this.getCountry.currency });
    }
    return 0;
  }

  get missingToForFreeDelivery() {
    const missingToForFreeDeliveryRaw =
      parseFloat(this.getCity.free_delivery_amount) -
      (this.getCart.total_decimal + this.getDiscountTotal);
    if (missingToForFreeDeliveryRaw < 0) {
      return 0;
    } else {
      return this.localCurrencyFormat(missingToForFreeDeliveryRaw);
    }
  }

  get missingToForFreeDeliveryPercent() {
    const missingToForFreeDeliveryRaw =
      parseFloat(this.getCity.free_delivery_amount) -
      (this.getCart.total_decimal + this.getDiscountTotal);
    let percent =
      100 - (missingToForFreeDeliveryRaw * 100) / this.getCity.free_delivery_amount;
    if (percent <= 100) {
      return percent;
    } else {
      return 100;
    }
  }

  get getCityReady() {
    return this.getCity && Object.keys(this.getCity).length > 0;
  }

  get getCouponApplied() {
    if(this.getCart && this.getCart.coupon_applied && this.getCart.coupon_data) {
      return this.getCart.coupon_data;
    }
    return false;
  }

  get getCouponDiscount() {
    if(this.getCouponApplied) {
      if (
        this.getCouponApplied.coupon_type === "percentage_discount" &&
        this.getCouponApplied.discount
      ) {
        const discount =
          parseFloat(this.getCouponApplied.discount) *
          this.currencyParse(this.getCart.subtotal);
        return this.localCurrencyFormat(discount);
      } else if(this.getCouponApplied.coupon_type === "monetary_discount") {
        const discount = (parseFloat(this.getCouponApplied.discount));
        return this.localCurrencyFormat(discount);
      } else if (this.getCouponApplied.coupon_type === 'free_delivery') {
        return "Domicilio Gratis";
      } else if (this.getCouponApplied.coupon_type === 'free_product') {
        return "Productos gratis";
      }
    }
    return "";
  }

  @Emit()
  onClose() {
  }

  keepBuying() {
    const query = this.$route.query;
    if (query.modalOpen) {
      this.$router.replace({ query: {} })
    }
    this.$emit('on-close');
  }

  @Emit()
  async onBtn() {
    this.$router.push({ name: 'checkout' })
  }

  _toggleCart() {
    this.OPEN_CART(false)
  }

  _onRouteCheckout() {
    this.$router.push({ name: 'checkout' })
  }
  /* Modal edit - add address */
  _toggleAddressModal() {
    if (this.getIsToken) {
      // this.showAddressModal = !this.showAddressModal
      this.$root.$emit('address-modal');
    } else {
      this._redirectToLogin('address');
    }
  }

  /* Modal program */
  _toggleProgramModal() {
    if (this.getIsToken) {
      // this.showProgramModal = !this.showProgramModal
      this.$root.$emit('program-modal');
    } else {
      this._redirectToLogin('program')
    }
  }

  /* Miscellany */
  _toLocaleString(value: number) {
    try {
      return localCurrency(value);
    } catch (error) {
      return 0
    }
  }

  _redirectToLogin(option: string) {
    const name = this.$route.name
    const query = this.$route.query
    const params = this.$route.params
    params["modal"] = option

    this.PATH_TEMPORAL({ name, params, query })
    this.$router.push({ name: 'login' })
  }

  _onShowCashbackMessage() {
    this.showCashbackMessage = true;
    try {
      this.$nextTick(() => {
        const element = document.getElementById("cashback");
        element.scrollIntoView();
      });
    } catch (error) {
      // Do nothing
    }
  }

  _openCouponField(open) {
    this.showAddCouponBtn = open;
  }

  _toggleCouponModal() {
    if(this.getIsToken) {
      this.OPEN_COUPON_MODAL(!this.getOpenCouponModal);
    } else {
      if(this.$route.query && (!this.$route.query.openCoupon)) {
        this.$router.replace({ query: {
          openCoupon: "true"
        }});
      }
      this._redirectToLogin("coupon-modal");
    }
  }

  async _onDeactivateCoupon() {
    if(this.getCouponApplied) {
      const couponApplied = this.getCouponApplied;
      try {
        if(couponApplied.code && couponApplied.code.length) {
          const requestBody = {
            coupon: {
              code: couponApplied.code
            }
          };
          await this.action_deactivateCartCoupon(requestBody);
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: `Error al desactivar cupón: ${error}`
        });
      }
    }
  }

  private localCurrencyFormat(value) {
    return localCurrency(value);
  }

  private currencyParse(value) {
    if (value.indexOf(".") !== -1) {
      value = value.split(".")[0];
      value = value.replace("$", "");
      value = value.replace(",", "");
      return parseFloat(value);
    }
    return value;
  }

  @Watch('getIsToken')
  onUserLogin() {
    if(this.getIsToken) {
      if (
        !this.getCurrentAddress &&
        this.getUser &&
        this.getUser.addresses &&
        this.getUser.addresses.length
      ) {
        this.CURRENT_ADDRESS(this.getUser.addresses[0]);
      }
    }
  }

  _truncate(value: string) {
    let response = value;
    let maxChars = 40;
    if(this.getIsUnderMobile) {
      maxChars = 30;
    }
    if(value && value.length && value.length > maxChars) {
      response = value.substr(0, maxChars) + "...";
    }
    return response;
  }
}
